export const Marquee = ({ items = [] }) => {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="marquee-band"
      className="overflow-hidden border-y border-[#D1C9B8] bg-[#EBE5D9] py-6"
    >
      <div className="ks-marquee-track flex gap-16 whitespace-nowrap">
        {doubled.map((t, i) => (
          <span
            key={i}
            className="font-serif italic text-2xl md:text-4xl text-[#1C2C22] flex items-center gap-16"
          >
            {t}
            <span className="text-[#C27A62]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
